import Splide from '@splidejs/splide';

let upsellCarouselInstance;
let packageCarouselInstance;
export const WbsMiniCart = () => {
    let timeout;


    $(document).on('change input', '.woocommerce-mini-cart .quantity .qty', function () {


        const input = $(this);
        const qtyVal = input.val();
        const itemID = input.parents('.woocommerce-mini-cart-item').data('key');
        const cart_hash_key = wc_cart_fragments_params.cart_hash_key;
        const fragment_name = wc_cart_fragments_params.fragment_name;


        clearTimeout(timeout);
        timeout = setTimeout(function () {


            input.parents('.mini_cart_item').addClass('loading');

            $.ajax({
                url: window.settings.ajaxurl, data: {
                    action: 'wbs_update_cart_item',
                    item_id: itemID, qty: qtyVal
                }, success: function (data) {
                    if (data && data.fragments) {
                        $.each(data.fragments, function (key, value) {
                            if ($(key).hasClass('widget_shopping_cart_content')) {
                                const dataItemValue = $(value).find('.woocommerce-mini-cart-item[data-key="' + itemID + '"]');
                                const dataFooterValue = $(value).find('.sidebar-cart__footer');
                                const upsellValue = $(value).find('.sidebar-cart__upsell');
                                const freeShippingValue = $(value).find('.sidebar-cart__free-shipping');
                                const $itemSelector = $(key).find('.woocommerce-mini-cart-item[data-key="' + itemID + '"]');

                                if (!data.cart_hash) {
                                    $(key).replaceWith(value);
                                } else {
                                    $itemSelector.replaceWith(dataItemValue);
                                    $('.sidebar-cart__footer').replaceWith(dataFooterValue);
                                    $('.sidebar-cart__upsell').replaceWith(upsellValue);
                                    $('.sidebar-cart__free-shipping').replaceWith(freeShippingValue);
                                }
                            } else {
                                $(key).replaceWith(value);
                            }
                        });


                        sessionStorage.setItem(fragment_name, JSON.stringify(data.fragments));
                        localStorage.setItem(cart_hash_key, data.cart_hash);
                        sessionStorage.setItem(cart_hash_key, data.cart_hash);

                        if (data.cart_hash) {
                            sessionStorage.setItem('wc_cart_created', (new Date()).getTime());
                        }

                        upsellCarousel(true);
                        packageCarousel(true);
                        $('body').trigger('wc_fragments_refreshed');

                    }
                }, dataType: 'json', method: 'GET'
            });
        }, 500);


    });

    $(document.body).on('wc_fragments_loaded', function () {
        upsellCarousel(true);
        packageCarousel(true);
    })
}

export const miniCartUpsellQuantity = () => {
    $(document).on('change input', '.sidebar-cart__upsell .quantity .qty', function () {
        const input = $(this);

        const qtyVal = input.val();

        const cartButton = input.parents('.product-card__cart').find('.button');


        cartButton.attr("data-quantity", qtyVal);


    });
}

export const toggleMiniCart = () => {
    const sidebarCart = document.querySelector('.sidebar-cart');

    const isCart = document.querySelector('.woocommerce-cart');
    const isCheckout = document.querySelector('.woocommerce-checkout');

    if (sidebarCart !== null && isCart === null && isCheckout === null) {


        const closeSidebarsOverlay = document.querySelector('.close-sidebars-overlay');
        const headerCartOpen = document.querySelectorAll('.headerCart');
        const innerSidebarClose = document.querySelectorAll('.sidebar-cart__close');

        let cartIsOpened = false;


        const openSidebarCart = () => {
            sidebarCart.classList.add('sidebar-fixed--opened');
            closeSidebarsOverlay.classList.add('close-sidebars-overlay--opened');
            document.body.classList.add('overflow-hidden');
            cartIsOpened = true;
            upsellCarousel();
            packageCarousel();
        };

        const closeSidebarCart = () => {
            sidebarCart.classList.remove('sidebar-fixed--opened');
            closeSidebarsOverlay.classList.remove('close-sidebars-overlay--opened');
            document.body.classList.remove('overflow-hidden');
            cartIsOpened = false;
        };

        headerCartOpen.forEach(open => {
            open.addEventListener('click', function (e) {
                e.preventDefault();
                openSidebarCart();
            });
        });

        const refreshCartFragment = () => {
            $(document.body).trigger('wc_fragment_refresh');

        };

        innerSidebarClose.forEach(close => {
            close.addEventListener('click', closeSidebarCart);
        });

        document.body.addEventListener('click', function (event) {
            if (event.target.matches('.sidebar-cart__close')) {
                closeSidebarCart();
            }
        });

        closeSidebarsOverlay.addEventListener('click', closeSidebarCart);

        $(document.body).on('added_to_cart', function () {
            if (cartIsOpened) {
                return;
            }

            refreshCartFragment();
            $(document.body).on('wc_fragments_refreshed', () => {
                openSidebarCart();
                let cartHideTimeout;


                if (window.settings.hasOwnProperty('cart_hide_time') && window.settings.cart_hide_time) {
                    clearTimeout(cartHideTimeout);

                    cartHideTimeout = setTimeout(() => {
                        closeSidebarCart();
                    }, window.settings.cart_hide_time);

                    $('.sidebar-cart__scroll').on('scroll', () => {
                        clearTimeout(cartHideTimeout);
                    });
                }
            });


        });
    }
};

function upsellCarousel(refresh = false) {
    const upsellCarouselElement = document.querySelector('.mini-upsell-carousel');

    if (!upsellCarouselElement) {
        return;
    }

    if (refresh && upsellCarouselInstance) {
        upsellCarouselInstance.destroy(); // Destroy the existing instance if refreshing
    }

    upsellCarouselInstance = new Splide(upsellCarouselElement, {
        perPage: 2,
        pagination: false,
        arrows: false,
        autoplay: false,
        mediaQuery: 'min',
        trimSpace: true,
        focus: 'center',
        gap: '0.5rem',
        padding: {left: '0.4rem', right: '4rem'},
        rewind: true,
        rewindByDrag: true,
    });

    upsellCarouselInstance.mount();

    const prevArrow = document.querySelector('.mini-upsell-carousel-prev');
    const nextArrow = document.querySelector('.mini-upsell-carousel-next');
    prevArrow.addEventListener('click', () => {
        upsellCarouselInstance.go('<');
    });

    nextArrow.addEventListener('click', () => {
        upsellCarouselInstance.go('>');
    });
}

function packageCarousel(refresh = false) {
    const packageCarouselElement = document.querySelector('.mini-package-carousel');

    if (!packageCarouselElement) {
        return;
    }

    if (refresh && packageCarouselInstance) {
        packageCarouselInstance.destroy();
    }

    packageCarouselInstance = new Splide(packageCarouselElement, {
         perPage: 2,
        pagination: false,
        arrows: false,
        autoplay: false,
        mediaQuery: 'min',
        trimSpace: true,
        focus: 'center',
        gap: '0.5rem',
        padding: {left: '0.4rem', right: '4rem'},
        rewind: true,
        rewindByDrag: true,
    });

    packageCarouselInstance.mount();
    const prevArrow = document.querySelector('.mini-package-carousel-prev');
    const nextArrow = document.querySelector('.mini-package-carousel-next');
    prevArrow.addEventListener('click', () => {
        packageCarouselInstance.go('<');
    });

    nextArrow.addEventListener('click', () => {
        packageCarouselInstance.go('>');
    });


}
